import {
	Divider,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { chronos } from "nhb-toolbox";
import { getFormattedCurrency } from "src/Helpers/utils";
import type { IAccountTransaction } from "src/Types/account.types";

interface Props {
	transactions: IAccountTransaction[];
}

const TransactionTable = ({ transactions }: Props) => {
	return (
		<Box sx={{ mt: 3 }}>
			<Typography style={{ marginBottom: "10px" }} variant='h4'>
				Transactions
			</Typography>
			<Divider />
			<TableContainer style={{ marginTop: "20px" }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Amount</TableCell>
							<TableCell>Details</TableCell>
							<TableCell>Last Balance</TableCell>
							<TableCell>Type</TableCell>
							<TableCell>Transaction Type</TableCell>
							<TableCell>Ledger Date</TableCell>
							<TableCell>Payment Method</TableCell>
							<TableCell>Voucher No.</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{transactions.map((transaction, idx) => (
							<TableRow key={transaction.id}>
								<TableCell>{idx + 1}</TableCell>
								<TableCell>
									{getFormattedCurrency(transaction.amount)}
								</TableCell>
								<TableCell>{transaction.details}</TableCell>
								<TableCell>
									{getFormattedCurrency(
										transaction.last_balance
									)}
								</TableCell>
								<TableCell>
									{transaction.type === "IN"
										? "Debit"
										: "Credit"}
								</TableCell>
								<TableCell>{transaction.tr_type}</TableCell>
								<TableCell>
									{chronos(transaction.ledger_date)
										.toLocal()
										.formatStrict(
											"dd, mmm Do, yy; hh:mm A"
										)}
								</TableCell>
								<TableCell>
									{transaction.payment_method || "N/A"}
								</TableCell>
								<TableCell>
									{transaction.voucher_no || "N/A"}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default TransactionTable;
